import pm from 'picomatch';
// True if value is exactly 5 digits (German PLZ format)
export const isFiveDigitGermanZip = (value) => {
    const safeValue = value !== null && value !== undefined ? value : '';
    const v = String(safeValue).trim();
    return /^\d{5}$/.test(v);
};
// Returns true if the given zip matches at least one allowed pattern.
export const zipIsAllowed = (zip, allowedPatterns = []) => {
    const safeZip = zip !== null && zip !== undefined ? zip : '';
    const v = String(safeZip).trim();
    if (!v || allowedPatterns.length === 0)
        return true; // no restriction configured → treat as allowed
    return allowedPatterns.some((pattern) => pm(pattern)(v));
};
// Returns true when the zip is a valid 5-digit number and not contained in the allowed patterns.
export const isZipOutOfArea = (zip, allowedPatterns = []) => {
    if (!isFiveDigitGermanZip(zip))
        return false;
    if (allowedPatterns.length === 0)
        return false; // nothing to compare against → not out of area
    return !zipIsAllowed(zip, allowedPatterns);
};
//# sourceMappingURL=zip.js.map